module.exports = __webpack_public_path__ + "static/img/73-2.282acdd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/73-2.jpg
// module id = hKU/
// module chunks = 0